import { Contract } from "./Contract";
import { Customer } from "./Customer";
import { LocationType } from "./Enums";
import { LoadBreakout } from "./LoadBreakout";
import { LocationListItem } from "./LocationListItem";

export class Dispatch {
    scheduleId: number = 0;
    dispatchId: number = 0;
    locationType: LocationType = LocationType.Origin;
    dispatchBeginDate: string = '';
    dispatchEndDate: string = '';

    location: LocationListItem = new LocationListItem();
    customer: Customer = new Customer();
    trucker: Customer = new Customer();
    contract: Contract = new Contract();

    loads: number = 0;
    rate: number = 0;
    rateString: string = '';
    rateUnitOfMeasure: string = '';
    currency: string = '';

    loadNumber: string = '';
    unloadNumber: string = '';
    loadNumberId: number = 0;
    unloadNumberId: number = 0;
    accountId: number = 0;

    loadNotes: string = '';
    locationNotes: string = '';
    internalNotes: string = '';
    loadBreakout: boolean = false;
    useDeliveryDate: boolean = false;
    status: string = '';
    roundId: number = 0;
    round: string = '';
    isOTC: boolean = false;
    equipmentType: string = '';
    equipmentWeight: string = '';
    equipmentWeightUOM: string = '';

    loadBreakoutList: LoadBreakout[] = [];

    enteredByEmail: string = '';
}
